export default __webpack_public_path__ + "static/media/Gardening-hover.bb611f26.svg";